import {
  Checkbox,
  FormGroup,
  FormSelector,
  Note,
  RadioGroup,
  Selector,
} from "@vesatogo/grass-core"
import { useParams, useSearchParams } from "react-router-dom"
import { FormCard } from "~/components/FormCard"
import { TradeKinds } from "~/constants/Kinds"
import SharedEntityGroup from "~/constants/SharedEntityGroup"
import { TRADE_KINDS } from "~/constants/static.items"

type HowIsItTradedProps = {
  form: any
  inputProps: any
  isDisabled?: boolean
  showBookingKinds?: boolean
  showInwardKinds?: boolean
  disableBookingPatti?: boolean
  type?: string
  useBuyerFacilitatorCompanies?: boolean
  hideMaterialKind?: boolean
  showIntercompany?: boolean
  disableIntercompany?: boolean
}
const HowIsItTraded = ({
  form,
  inputProps,
  isDisabled = false,
  showBookingKinds = false,
  showInwardKinds = false,
  disableBookingPatti = false,
  type,
  useBuyerFacilitatorCompanies,
  hideMaterialKind,
  showIntercompany = false,
  disableIntercompany = false,
}: HowIsItTradedProps) => {
  const { id } = useParams()
  const [searchParams] = useSearchParams()

  const isOrderPatti = searchParams.get("type") === TradeKinds.OrderPatti

  const facilitatorCompanies = useBuyerFacilitatorCompanies
    ? form.values.buyer?.companies
    : form.values.seller?.companies
  return (
    <FormCard title="How is it traded">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className={"w-full col-span-2"}>
          {type ? (
            <FormSelector
              className={"mb-3"}
              label="Type"
              required
              value={{ id: type, name: type } as any}
              disabled={true}
            />
          ) : (
            <RadioGroup
              className={"mb-3 flex col-span-2"}
              radiosClassName="flex !flex-col md:!flex-row flex-wrap"
              label="Type"
              required
              {...inputProps("kind")}
            >
              {TRADE_KINDS.filter(kind => {
                if (!showBookingKinds && kind.id === TradeKinds.Booking)
                  return false
                if (!showInwardKinds && kind.id === TradeKinds.InwardPatti)
                  return false
                if (!isOrderPatti && kind.id === TradeKinds.OrderPatti)
                  return false

                return true
              }).map((kind, i) => (
                <Checkbox
                  key={i}
                  type={"radio"}
                  value={kind.id}
                  label={kind.name}
                  disabled={
                    id !== "new"
                      ? !searchParams.get("newfpr")
                      : false ||
                        (kind.id === TradeKinds.Booking &&
                          disableBookingPatti) ||
                        form.values.kind === TradeKinds.OrderPatti ||
                        searchParams.get("type") === TradeKinds.SaudaPavti
                  }
                />
              ))}
            </RadioGroup>
          )}
          {form.values.kind === TradeKinds.HishobPatti ? (
            <Note className="text-sm">
              No information can be changed later. The invoice will be created
              directly now.
            </Note>
          ) : type ? null : (
            <Note intent="warning" className="text-yellow-600 text-sm">
              This is temporary and is subject to change later.
            </Note>
          )}
        </div>

        <RadioGroup
          className={"w-full"}
          label="Mode"
          required
          {...inputProps("mode")}
        >
          <Checkbox
            type={"radio"}
            value="direct"
            label="Direct"
            disabled={isDisabled}
          />
          <Checkbox
            type={"radio"}
            value="facilitator"
            label="Via Facilitator"
            disabled={isDisabled || !facilitatorCompanies?.length}
          />
        </RadioGroup>
        {form.values.mode === "facilitator" ? (
          <FormGroup label="Facilitator Company" className={""}>
            <Selector
              options={facilitatorCompanies?.map(c => c?.company)}
              {...inputProps("facilitator", {
                group: SharedEntityGroup.KiteCompany,
              })}
              isDisabled={isDisabled}
            />
          </FormGroup>
        ) : (
          <div />
        )}
        {hideMaterialKind ? null : (
          <RadioGroup
            className={"w-full"}
            label="Material Type"
            required
            disabled={true}
            {...inputProps("material_kind")}
          >
            <Checkbox
              type={"radio"}
              value="commodity"
              label="Commodity"
              disabled={true}
            />
            <Checkbox
              type={"radio"}
              value="packaging"
              label="Packaging"
              disabled={true}
            />
          </RadioGroup>
        )}
        {showIntercompany ? (
          <RadioGroup
            // className={"w-full"}
            label="Inter-Company Transaction"
            {...inputProps("is_intercompany_transaction")}
          >
            <Checkbox
              type={"radio"}
              value="yes"
              label="Yes"
              disabled={isDisabled || disableIntercompany}
            />
            <Checkbox
              type={"radio"}
              value="no"
              label="No"
              disabled={isDisabled || disableIntercompany}
            />
          </RadioGroup>
        ) : null}
      </div>
    </FormCard>
  )
}

export default HowIsItTraded
